import { dataDownload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDownload = /*#__PURE__*/createIcon(dataDownload)
export default IconDownload
